module.exports = __webpack_public_path__ + "media/images/9570-b984014dc1bc8518cda4db68623f9523.png";